import { render } from "./CheckboxGroup.vue?vue&type=template&id=18e78f7c"
import script from "./CheckboxGroup.vue?vue&type=script&lang=ts"
export * from "./CheckboxGroup.vue?vue&type=script&lang=ts"
script.render = render

export default script